'use client';
import { useEffect, useRef } from 'react';
import { createRoot, Root } from 'react-dom/client';
import { ChartProps } from '@/types/chart';
import { BarChart, PieChart } from './chart';

export function ClientSideRenderChart({ chart }: { chart: ChartProps }) {
  const rootRef = useRef<Root | null>(null);
  const chartContainerRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (!chartContainerRef.current) {
      chartContainerRef.current = document.getElementById('chart');
    }

    if (chartContainerRef.current && !rootRef.current) {
      // Create the root only once
      rootRef.current = createRoot(chartContainerRef.current);
    }

    if (rootRef.current) {
      // Render the chart based on its type
      if (chart.type === 'pie') {
        rootRef.current.render(<PieChart chart={chart} />);
      } else if (chart.type === 'bar') {
        rootRef.current.render(<BarChart chart={chart} />);
      }
    }
  }, [chart]);

  return null;
}
